var $ = require('jquery');

module.exports = (function(){
  var button = $('.js-services-button');
  var buttonClose = $('.js-services-close');
  var tab = $('.js-services-tab');
  var tabMobile = $('.js-services-tab-mobile');
  var lastId = -1;
  var animating = false;

  // // Touch + hover fix
  // $('.nav-popup__list a').on('touchend', function(e) {
  //     var el = $(this);
  //     var link = el.attr('href');
  //     window.location = link;
  // });

  // // Touch + hover fix
  // $('.navbar__list a').on('touchend', function(e) {
  //     var el = $(this);
  //     var link = el.attr('href');
  //     window.location = link;
  // });

  $(button).on('tap click', function(){
    $(button).removeClass('-active');
    $(this).addClass('-active');
    var id = $(this).data('id');
    (!animating) && toggleTab(id - 1);
  });

  $(buttonClose).on('tap click', function(){
    $(button).removeClass('-active');
    var id = $(this).data('id');
    (!animating) && toggleTab(id - 1);
    lastId = -1;
  });

  function toggleTab(id) {
    if (lastId !== id) {
      $(tab).hide();
      $(tabMobile).hide();
      animateTab(id, 'close');
      $(tabMobile).eq(id).show();
      $(tab).eq(id).show();

        if ($(window).width() < 920) { // if mobile/tablet
          var paddingTop =  1; //$(tabMobile).eq(id).find('h2').css('padding-top').replace('px', '');
          var offsetTop = $(tabMobile).eq(id).find('h2').offset().top;
        }else{
          var paddingTop =  10; //$(tab).eq(id).find('h2').css('padding-top').replace('px', '');
          var offsetTop = $(tab).eq(id).find('h2').offset().top;
        }

        $('body').stop().animate({
          scrollTop: parseInt( (offsetTop + paddingTop) - 98 ) + 'px'
        }, 1500);

        lastId = id;

    }else{
      $(button).removeClass('-active');
      animateTab(id);
      lastId = -1;
    }
  }

  function animateTab(id, direction = 'open') { // todo: fix spaghetti to function + fix css to array
    if (animating == false) {
      animating = true;
      if (direction == 'close') {
        var tempHeight = $(tab).eq(id).css('position', 'absolute').css('visibility', 'hidden').css('display', 'block').height();
        $(tab).eq(id).css('position', '').css('visibility', '').css('display', '').css('height', '0');
        $(tab).eq(id).animate({height: tempHeight }, 1000, function() {
          $(tab).eq(id).height('auto');
          animating = false;
        });
        var tempHeightMobile = $(tabMobile).eq(id).css('position', 'absolute').css('visibility', 'hidden').css('display', 'block').height();
        $(tabMobile).eq(id).css('position', '').css('visibility', '').css('display', '').css('height', '0');
        $(tabMobile).eq(id).animate({height: tempHeightMobile }, 1000, function() {
          $(tabMobile).eq(id).height('auto');
          animating = false;
        });
      }else{
        $(tab).eq(id).animate({height: 40 }, 1000, function() {
          $(tab).eq(id).height('auto');
          $(tab).hide();
          animating = false;
        });
        $(tabMobile).eq(id).animate({height: 40 }, 1000, function() {
          $(tabMobile).eq(id).height('auto');
          $(tabMobile).hide();
          animating = false;
        });
      }
    }
  }
})();



// WEBPACK FOOTER //
// ./components/services.js